module.exports = {
  DEPARTURE: 'DEPARTURE',
  ARRIVAL: 'ARRIVAL',
};
